"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundingSpecV1 = void 0;
exports.formatQuantity = formatQuantity;
exports.formatPercentage = formatPercentage;
exports.formatMinutes = formatMinutes;
const decimal_js_1 = require("decimal.js");
/**
 * Rounding contract v1 (FORMULA_AND_CALCULATION_MAP.md §3, locked —
 * PHASE2A_REVISION_CHANGELOG.md A1): 2 decimals, HALF_AWAY_FROM_ZERO.
 * Rounding happens EXCLUSIVELY here, EXCLUSIVELY at display time — raw
 * Decimal values flow through line-formula/aggregation unrounded.
 *
 * decimal.js `ROUND_HALF_UP` rounds ties away from zero for both signs,
 * which is exactly HALF_AWAY_FROM_ZERO (not decimal.js's own "half up"
 * naming ambiguity — verified against negative-value fixtures in tests).
 */
const DECIMALS = 2;
const MODE = decimal_js_1.Decimal.ROUND_HALF_UP;
function formatQuantity(raw) {
    if (raw === null)
        return null;
    return raw.toFixed(DECIMALS, MODE);
}
function formatPercentage(raw) {
    if (raw === null)
        return null;
    return raw.mul(100).toFixed(DECIMALS, MODE);
}
function formatMinutes(raw) {
    if (raw === null)
        return "0";
    return raw.toFixed(0, MODE);
}
exports.roundingSpecV1 = {
    decimals: DECIMALS,
    mode: "HALF_AWAY_FROM_ZERO",
};
//# sourceMappingURL=rounding.js.map